<script setup lang="ts">
import { computed } from 'vue'

import ErrorList from './ErrorList.vue'

import Unfold from '@material-symbols/svg-400/outlined/unfold_more.svg'

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const props = withDefaults(
  defineProps<{
    id?: string
    modelValue?: any
    icon?: any
    label?: string
    placeholder?: string
    errors?: string[]
    items: any[]
    itemValue: string
    itemTitle: string
  }>(),
  { items: () => [] }
)

const onChange = (evt: Event) => {
  emit('update:modelValue', (evt.target as HTMLSelectElement).value)
}

const hasErrors = computed(() => props.errors && props.errors?.length > 0)
</script>
<template>
  <label :for="props.id" :class="{ error: hasErrors }">{{ props.label }}</label>
  <div class="flex flex-col mt-2 space-y-2 min-h-[70px]">
    <div :class="['form-field', { error: hasErrors }]">
      <div class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
        <component :is="icon" class="h-5 w-5" aria-hidden="true" />
      </div>
      <select
        :id="props.id"
        :value="props.modelValue"
        @change="onChange"
        :class="[
          'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 sm:text-sm sm:leading-6 appearance-none pl-10 py-1.5 w-full outline-none rounded-md shadow-sm ring-1 ring-inset focus:shadow-inner focus:ring-2 focus:ring-sky-400 dark:focus:ring-sky-600 ring-gray-300',
          { 'dark:text-gray-400': !props.modelValue }
        ]"
      >
        <option value="" disabled selected hidden>{{ props.placeholder }}</option>
        <option
          v-bind:key="item[props.itemValue]"
          v-for="item in items"
          :value="item[props.itemValue]"
        >
          {{ item[props.itemTitle] }}
        </option>
      </select>
      <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
        <Unfold :class="['h-5 w-5 fill-gray-400', { 'fill-red-400': hasErrors }]" />
      </span>
    </div>
    <ErrorList :errors="props.errors" />
  </div>
</template>
<style scoped></style>
